import { render, staticRenderFns } from "./commission-add.pug?vue&type=template&id=1b8f13b2&lang=pug&"
import script from "./commission-add.ts?vue&type=script&lang=ts&"
export * from "./commission-add.ts?vue&type=script&lang=ts&"
import style0 from "./commission-add.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports